import { ComposedChart, Scatter, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const ScatterPlot = ({ data, regressionLine }) => {
  const sortedData = [...data].sort((a, b) => a.x - b.x)
  const firstPoint = sortedData[0]
  const lastPoint = sortedData[sortedData.length - 1]
  const xMin = Math.min(...data.map(v => v.x))
  const xMax = Math.max(...data.map(v => v.x))

  const linePoints = regressionLine ? [
    { x: firstPoint.x, y: regressionLine.m * firstPoint.x + regressionLine.b },
    { x: lastPoint.x, y: regressionLine.m * lastPoint.x + regressionLine.b }
  ] : [
    { x: 0, y: 0 },
    { x: xMax, y: xMax }
  ]

  return (
    <ResponsiveContainer width="100%" height={400}>
      <ComposedChart
        margin={{
          top: 20, right: 20, bottom: 20, left: 20,
        }}
      >
        <CartesianGrid />
        <XAxis type="number" dataKey="x" name="X Value" domain={[ xMin, xMax ]} />
        <YAxis type="number" dataKey="y" name="Y Value" />
        <Tooltip cursor={{ strokeDasharray: '3 3' }} />
        <Scatter name="Data Points" data={data} fill="#8884d8" />
        <Line type="monotone" dataKey="y" data={linePoints} stroke="#ff7300" />
      </ComposedChart>
    </ResponsiveContainer>
  )
}

export default ScatterPlot
